var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricemonitorLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176.61 167.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:#ed2e85;}.cls-1{opacity:0.08;}.cls-2{opacity:0.1;}.cls-3{opacity:0.18;}.cls-5{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text_copy",
    "data-name": "text copy"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 79.66,
    cy: 65,
    r: 65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 79.66,
    cy: 65,
    r: 49.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 79.66,
    cy: 65,
    r: 34.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.66,
    cy: 66,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M0,78H10.76v4.21A15.29,15.29,0,0,1,22.9,76.69c13.58,0,18.69,11.93,18.69,20.83,0,11-7.73,20.07-18.62,20.07-6.9,0-10.14-3.31-11.52-4.76V129H0ZM30.14,97.11a9.56,9.56,0,0,0-9.59-9.73,9.41,9.41,0,0,0-6.89,2.9,10,10,0,0,0-2.69,7,9.59,9.59,0,1,0,19.17-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48,78H58.76v4.28c1.11-2.07,3.11-5.59,9.73-5.59V88.21h-.42c-5.86,0-8.62,2.14-8.62,7.52v20.55H48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.8,78H85.25v38.28H73.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.21,101.73A20.56,20.56,0,0,1,91.66,97a20.1,20.1,0,0,1,20.21-20.35c10.14,0,18.34,6.69,20.28,16.07H120.56a8.58,8.58,0,0,0-8.28-5.38,8.21,8.21,0,0,0-6.62,2.69,10.52,10.52,0,0,0-2.48,7c0,5.58,3.65,9.72,9.1,9.72a8.8,8.8,0,0,0,8.28-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.87,101.11c.48,4.07,4.35,6.76,8.83,6.76a7.71,7.71,0,0,0,7-3.59h11.73a22.37,22.37,0,0,1-7.79,9.79,18.6,18.6,0,0,1-10.9,3.45,20.31,20.31,0,0,1-20.28-20.28c0-10.69,8.42-20.55,20.07-20.55A19.62,19.62,0,0,1,171,82.76c4.82,5.17,6.27,11.31,5.37,18.35Zm17.24-8.69c-.27-1.8-2.62-6.07-8.55-6.07s-8.28,4.27-8.55,6.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.89,141H6.62v3.22a8.4,8.4,0,0,1,7.45-4,8.34,8.34,0,0,1,6.29,2.61,11.54,11.54,0,0,1,1.53,2.33,10.68,10.68,0,0,1,1.86-2.42,9.37,9.37,0,0,1,6.52-2.52,9.4,9.4,0,0,1,6.8,2.56c2.33,2.42,2.8,4.52,2.8,9.78v14h-6.1V152.76a8.65,8.65,0,0,0-1-4.75c-.65-1.25-1.86-2.09-4-2.09a4.81,4.81,0,0,0-4.43,2.33,8.07,8.07,0,0,0-.88,4.28v14h-6.1v-14a9.35,9.35,0,0,0-.79-4.24,4.5,4.5,0,0,0-4.19-2.37A4.76,4.76,0,0,0,8,148.29a9.14,9.14,0,0,0-1,4.43v13.83H.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.44,153.7a13.29,13.29,0,0,1,13.69-13.46,13.53,13.53,0,1,1,0,27,13.3,13.3,0,0,1-13.69-13.55Zm6.1.09a7.57,7.57,0,1,0,7.59-7.87,7.58,7.58,0,0,0-7.59,7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.53,141h5.73c0,1.12,0,2.19-.05,3.4,1.12-2,3.4-4.24,8-4.19,8.34.05,9.92,6.43,9.92,10.94v15.42H94V152.67c0-3.82-1.26-6.75-5.54-6.75s-5.82,2.93-5.82,6.52v14.11h-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M106.06,132.09h6.1v5.45h-6.1Zm0,8.89h6.1v25.57h-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.84,145.69H115.6V141h4.24v-8.89h6.1V141h4.38v4.71h-4.38v20.86h-6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M131.39,153.7a13.7,13.7,0,1,1,13.69,13.59,13.29,13.29,0,0,1-13.69-13.59Zm6.1.09a7.57,7.57,0,1,0,7.59-7.87,7.58,7.58,0,0,0-7.59,7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.44,141h5.77v3.35c1.12-2.28,3.21-4.09,7.08-4.14v6.15H176c-4.28,0-6.47,2-6.47,6.42v13.79h-6.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricemonitorLogo);
export default __webpack_public_path__ + "static/media/pricemonitor_logo.73d368a0.svg";
export { ForwardRef as ReactComponent };